import { ReportEntity } from '@data';

export interface ProductHoursRow {
  productId: string;
  productName: string;
  minutes: number;
}

/** Heaviest first. A product with no time in the window is absent rather than a zero row. */
export const productHours = (reports: ReportEntity[] | undefined): ProductHoursRow[] => {
  const byProduct = (reports ?? [])
    .filter(report => report.involvement?.product?.id)
    .reduce((rows, report) => {
      const { id, name } = report.involvement.product;
      const row = rows.get(id);

      if (row) row.minutes += report.minutes ?? 0;
      else rows.set(id, { productId: id, productName: name, minutes: report.minutes ?? 0 });

      return rows;
    }, new Map<string, ProductHoursRow>());

  // By name within the same total, so two products at equal hours do not swap places between renders.
  return [...byProduct.values()].sort((a, b) => b.minutes - a.minutes || a.productName.localeCompare(b.productName));
};

export const totalMinutes = (rows: ProductHoursRow[]): number => rows.reduce((sum, row) => sum + row.minutes, 0);
